<ng-template #modalEmailPreview let-c="close" let-d="dismiss">
  <wsb-modal primaryButtonText="{{ 'common_cancel' | translate }}" (primary)="d()" (dismiss)="d()" title="{{ 'mail_preview' | translate }}">
    <div body>
      <div [innerHtml]="selectedEmailPreview"></div>
    </div>
  </wsb-modal>
</ng-template>

<wsb-atlas-grid
  #grid
  [@gridIsLoaded]="gridAnimationState"
  class="atlas-grid-simplest"
  class="mt-2"
  [columnDefs]="tableColumnsDefs"
  [options]="tableGridOptions"
  [rowData]="tableRowData"
  [showFilters]="true"
  [components]="components"
>
</wsb-atlas-grid>
